import { Copy, Save, CheckCircle2, Rocket } from "lucide-react";

export function PublishActionsBar({ draft, saving, overLimit, canPublish, linkedinReady, liConnected, liHasOrgId, onCopyLinkedin, onSave, onApprove, onOpenPublish }) {
  const linkedinHint = linkedinReady
    ? null
    : !liConnected
      ? "LinkedIn not connected yet — connect it in Settings, or use Copy for LinkedIn below for a manual post."
      : !liHasOrgId
        ? "LinkedIn is connected, but you still need to set your Organization ID in Settings to publish."
        : "LinkedIn needs reconnecting in Settings.";
  return (
    <>
      <div className="border-t border-slate-100 pt-5 space-y-2.5">
        <button data-testid="open-publish-modal-btn" onClick={onOpenPublish} disabled={!canPublish}
          className="w-full flex items-center justify-center gap-2 py-3 rounded-full bg-rose-500 text-white text-sm font-semibold hover:bg-rose-600 transition-colors duration-150 shadow-sm disabled:opacity-30 disabled:cursor-not-allowed">
          <Rocket size={14} /> Publish
        </button>
        {linkedinHint && (
          <p className="text-[11px] text-slate-400 text-center -mt-1">{linkedinHint}</p>
        )}
        <div className="grid grid-cols-3 gap-2">
          <button data-testid="save-draft-btn" onClick={onSave} disabled={saving || overLimit}
            className="flex items-center justify-center gap-2 py-2.5 rounded-full border border-slate-200 text-[#0f172a] text-xs font-semibold hover:bg-slate-50 transition-colors duration-150 disabled:opacity-40">
            <Save size={13} /> Save
          </button>
          <button data-testid="approve-btn" onClick={onApprove} disabled={saving || overLimit || draft.status === "published"}
            className="flex items-center justify-center gap-2 py-2.5 rounded-full border border-indigo-200 bg-indigo-50 text-indigo-600 text-xs font-semibold hover:bg-indigo-100 transition-colors duration-150 disabled:opacity-40">
            <CheckCircle2 size={13} /> Approve
          </button>
          <button data-testid="copy-linkedin-btn" onClick={onCopyLinkedin}
            className="flex items-center justify-center gap-2 py-2.5 rounded-full border border-[#0a66c2]/30 bg-[#0a66c2]/5 text-[#0a66c2] text-xs font-semibold hover:bg-[#0a66c2]/10 transition-colors duration-150">
            <Copy size={13} /> Copy
          </button>
        </div>
      </div>
      {draft.status !== "approved" && draft.status !== "published" && (
        <p className="text-[11px] text-slate-400">Approve the draft to unlock publishing.</p>
      )}
      {draft.status === "published" && (
        <p data-testid="published-indicator" className="text-[11px] text-emerald-600 font-medium">
          Published{draft.linkedin_post_id ? ` · LinkedIn ${draft.linkedin_post_id}` : ""}
          {draft.blog_url && <> · <a href={draft.blog_url} target="_blank" rel="noopener noreferrer" className="underline hover:text-emerald-700">blog article</a></>}
        </p>
      )}
    </>
  );
}

